import "./index.css";
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import Table from "./components/ExportEwaybillHistoryTable";
import { getEwaybillRecordList } from "@/services/api/details";
import { Button, Card } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

class ExportEwaybillHistory extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tableLoading: false,
      pageNo: 1,
      pageSize: 10,
      data: {},
    };
    this.onTableChange = this.onTableChange.bind(this);
    this.getInfo();
  }
  /**
   * 获取导出记录列表
   */
  async getInfo() {
    const { pageNo, pageSize } = this.state;
    const result = await getEwaybillRecordList({ pageNo, pageSize });
    if (!result.errorCode) {
      this.setState({
        data: result,
      });
    }
  }

  // 监听表格变化
  onTableChange(current, pageSize) {
    console.log(current, pageSize, "pageSize");
    this.setState(
      {
        pageNo: current,
        pageSize,
      },
      () => {
        this.getInfo();
      }
    );
  }

  render() {
    const { tableLoading, data } = this.state;

    return (
      <Card>
        <div className="mb20" style={{ marginBottom: 20 }}>
          明细文件保留七天，请及时下载
        </div>

        <Table size="small" data={data} onChange={this.onTableChange} loading={tableLoading}></Table>
      </Card>
    );
  }
}

export default withRouter(ExportEwaybillHistory);
